import { render } from "./answerDetail.vue?vue&type=template&id=4831105f&scoped=true"
import script from "./answerDetail.vue?vue&type=script&lang=js"
export * from "./answerDetail.vue?vue&type=script&lang=js"

import "./answerDetail.vue?vue&type=style&index=0&id=4831105f&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-survey/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4831105f"]])

export default __exports__